<div
  tooltipClass="tooltip-class"
  kendoTooltip
  position="right"
  [tooltipTemplate]="hinweistextTemplate"
  filter="i[data-hinweistext]"
>
  <ng-container *ngIf="header">
    <h2 class="small-h2">
      {{ header.merkmal
      }}<i
        [attr.data-hinweistext]="header.hinweisTextHtml"
        *ngIf="header.hinweisTextHtml"
        class="far fa-question-circle"
        aria-hidden="true"
      ></i>
      <br /><span *ngIf="sachverhaltId || erfassungSachverhaltId" style="font-size: 0.6em; font-style: italic">
        ({{ 'components.dossier.sachverhaltId' | translate }}:
        {{ sachverhaltId ? sachverhaltId : erfassungSachverhaltId }})</span
      >
    </h2>
  </ng-container>
  <div class="fields-wrapper">
    <ng-container *ngFor="let field of fields" [ngSwitch]="field.type">
      <div *ngSwitchCase="'subset'" class="subset">
        <div
          *ngFor="let row of values[field.key]; let rowIndex = index; let even = even; let odd = odd"
          class="fields-grid"
          [ngClass]="{ 'subset-style-a': even, 'subset-style-b': odd }"
        >
          <div class="full-row subset-item-actions">
            <small>({{ rowIndex + 1 }}/{{ values[field.key].length }})</small>
            <button
              [title]="'dialog.deleteValue' | translate"
              [attr.aria-label]="'dialog.deleteValue' | translate"
              (click)="deleteWert(field.key, rowIndex)"
              class="btn btn-default btn-sm"
            >
              <i class="fas fa-trash-alt fa-sm" aria-hidden="true"></i>
            </button>
          </div>

          <ng-container *ngFor="let subsetField of field.fields">
            <div>
              <label
                class="control-label"
                [ngClass]="{ red: errorFields.has(subsetField.key | subsetFieldName: field.key : rowIndex) }"
                [for]="'subset-' + field.key + '-' + rowIndex + '-' + subsetField.key"
              >
                {{ subsetField.label }}
                <span
                  *ngIf="subsetField.required"
                  [ngClass]="{ red: errorFields.has(subsetField.key | subsetFieldName: field.key : rowIndex) }"
                  >*
                </span>
              </label>
            </div>
            <div [ngClass]="{ 'subset-style-a': even, 'subset-style-b': odd }">
              <div class="input-group" [attr.data-isrequired]="field.required" [attr.data-itemkey]="field.key">
                <app-dynamic-control
                  [field]="subsetField"
                  [optionValues]="values[field.key][rowIndex]"
                  [value]="values[field.key][rowIndex][subsetField.key]"
                  [controlId]="'subset-' + field.key + '-' + rowIndex + '-' + subsetField.key"
                  (textValueChange)="onTextValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (rangeChanged)="onRangeChanged($event.value, $event.fieldKey, rowIndex, field.key)"
                  (intValueChange)="onIntValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (dateChange)="onDateChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey, rowIndex, field.key)"
                >
                </app-dynamic-control>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="subset-actions">
          <small>{{ GetLabelsForSubset(field) }}</small>
          <button
            [attr.aria-label]="'action.addWert' | translate"
            (click)="addWert(field.key, field.type)"
            id="btn-add-subset"
            style="margin-left: 10px"
            class="button-icon-only"
          >
            <i class="fas fa-plus fa-sm" aria-hidden="true"></i>
            {{ 'action.add' | translate }}
          </button>
        </div>
      </div>

      <ng-container *ngSwitchDefault>
        <div class="fields-grid">
          <div>
            <label class="control-label" [ngClass]="{ red: errorFields.has(field.key) }" [for]="'field-' + field.key">
              {{ field.label }}<span *ngIf="field.required" [ngClass]="{ red: errorFields.has(field.key) }">*</span>

              <i
                [attr.data-hinweistext]="field.hinweisTextHtml"
                *ngIf="field.hinweisTextHtml"
                class="far fa-question-circle"
                aria-hidden="true"
              ></i>

              <button
                *ngIf="field.multiple"
                [title]="'dialog.addValue' | translate"
                [attr.aria-label]="'dialog.addValue' | translate"
                (click)="addWert(field.key, field.type)"
                class="button-icon-only"
                style="margin-inline: 0.5em"
              >
                <i class="fas fa-plus fa-sm" aria-hidden="true"></i>
              </button>
            </label>
          </div>
          <div>
            <div *ngIf="field.multiple">
              <div
                *ngFor="let value of values[field.key]; let i = index; trackBy: trackByIndex"
                class="input-group"
                [attr.data-isrequired]="field.required"
                [attr.data-itemkey]="field.key"
              >
                <app-dynamic-control
                  [field]="field"
                  [optionValues]="values"
                  [value]="value"
                  [controlId]="'field-' + field.key + '-' + i"
                  (textValueChange)="onTextValueChange($event.value, $event.fieldKey, i)"
                  (rangeChanged)="onRangeChanged($event.value, $event.fieldKey, i)"
                  (intValueChange)="onIntValueChange($event.value, $event.fieldKey, i)"
                  (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey, i)"
                  (dateChange)="onDateChange($event.value, $event.fieldKey, i)"
                  (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey, i)"
                  (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey, i)"
                >
                </app-dynamic-control>
                <div class="input-group-btn">
                  <button
                    [title]="'dialog.deleteValue' | translate"
                    [attr.aria-label]="'dialog.deleteValue' | translate"
                    (click)="deleteWert(field.key, i)"
                    class="btn btn-outline-danger btn-sm"
                  >
                    <i class="fas fa-trash-alt fa-sm" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="input-group"
              *ngIf="!field.multiple"
              [attr.data-isrequired]="field.required"
              [attr.data-itemkey]="field.key"
            >
              <app-dynamic-control
                [field]="field"
                [optionValues]="values"
                [value]="values[field.key]"
                [controlId]="'field-' + field.key"
                (textValueChange)="onTextValueChange($event.value, $event.fieldKey)"
                (rangeChanged)="onRangeChanged($event.value, $event.fieldKey)"
                (intValueChange)="onIntValueChange($event.value, $event.fieldKey)"
                (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey)"
                (dateChange)="onDateChange($event.value, $event.fieldKey)"
                (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey)"
                (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey)"
              >
              </app-dynamic-control>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div *ngIf="serverValidationErrors.summary.length > 0">
    <div class="alert alert-danger" role="alert">
      <ul>
        <li *ngFor="let validationErrorText of serverValidationErrors.summary">
          {{ validationErrorText }}
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #hinweistextTemplate let-anchor>
  <div style="padding: 10px" [innerHtml]="parseMultilineString(anchor.nativeElement.getAttribute('data-hinweistext'))">
  </div>
</ng-template>
